export default __webpack_public_path__ + "static/TX3-56dc7c5ca6d901948077228f0391b28a.svg";